export class ConfigDB {
	static data = {
		"settings":
		{
			"layout_type": "ltr",
			// "sidebar":
			// {
			// 	"type": "default",
			// 	"body_type": "default"
			// },
			"sidebar":
			{
				"type": "compact-wrapper",
				"body_type": "sidebar-icon"
			},

			// "sidebar_setting":
			// 	"iconcolor-sidebar",
			"sidebar_setting":
				"default",
			"sidebar_backround":
				"dark-sidebar"
		},
		"color":
		{
			"layout_version": null,
			"color": null,
			"primary_color": null,
			"secondary_color": null,
			"mix_layout": "default"
		},
		"router_animation": "fadeIn"
	}
}

